export const PROJECT_ENTITIES = ['local','international'] as const;
